import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Wishlistdescription.css";
import Header from "../KalHome/Header";
import Preheader from "../KalHome/Preheader";
import Footer from "../Homecomponents/Footer";
import Superheader from "../KalHome/Superheader";

const Wishlistdescription = () => {
    const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const { state } = useLocation();
  const desproduct = state.product;
  console.log(desproduct, "desproduct");

  const [showModal, setShowModal] = useState(false);

  const [modalImage, setModalImage] = useState("");
  const userData1 = JSON.parse(sessionStorage.getItem("user"));

  const [add, setAdd] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  const [selectedSize, setSelectedSize] = useState("");
  const handleSizeClick = (size) => {
    setSelectedSize(size);
  };

  const fetchProductData = async () => {
    try {
      const responseAddToCart = await fetch(
        `https://api.dremerz.net/api/Kalanjiyam_Products_AddToCart?email=${userData1.email}`
      );

      const dataAddToCart = await responseAddToCart.json();
      console.log(dataAddToCart);

      const brandNamesAddToCart = dataAddToCart.map(
        (product) => product.productBrandName
      );

      setAdd(brandNamesAddToCart);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };
  const handleAddtocart = async (product) => {
    // Retrieve and parse user data from session storage
    const userData = sessionStorage.getItem("user");

    if (!userData) {
      // If session data doesn't exist, alert the user to login
      setShowAlert(true);
      return;
    }

    // Parse the user data from session storage
    const user = JSON.parse(userData);

    try {
      // Save the product data to session storage (optional)
      sessionStorage.setItem("cartProduct", JSON.stringify(product));

      // Create a FormData object to send data as form data
      const formData = new FormData();

      // Append product details to formData
      formData.append("productId", product.productId);
      formData.append("productImage", product.productImage);
      formData.append("productBrandName", product.productBrandName);
      formData.append("productPrice", product.productPrice);
      formData.append("productDescription", product.productDescription);
      formData.append("productOption1", product.productOption1);
      formData.append("productOption2", product.productOption2);
      formData.append("productOption3", product.productOption3);
      formData.append("productTag", product.productTag);
      formData.append("productBrand", product.productBrand);
      formData.append("productOriginalPrice", product.productOriginalPrice);
      formData.append("productDealId", product.productDealId);
      formData.append("productGalleryImage", product.productGalleryImage);
      formData.append("productGalleryImage1", product.productGalleryImage1);
      formData.append("productGalleryImage2", product.productGalleryImage2);
      formData.append("productGalleryImage3", product.productGalleryImage3);
      formData.append("productGalleryImage4", product.productGalleryImage4);
      formData.append("productVariants", product.variants);

      // Append user details to formData
      formData.append("userId", user.id);
      formData.append("fullname", user.fullname);
      formData.append("email", user.email);
      formData.append("mobile", user.mobile);
      formData.append("password", user.password);
      formData.append("confirmPassword", user.confirmPassword);

      // Send the product and user information as form data to the API
      const response = await axios.post(
        "https://api.dremerz.net/api/Kalanjiyam_Products_AddToCart",
        formData
      );

      console.log("Product added to cart:", response.data);

      // navigate("/checkout", { state: { product } });
      fetchProductData();
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }
  };
  useEffect(
    () => {
      fetchProductData();
    },
    [userData1.email],
    handleAddtocart
  );

  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage("");
  };

  if (!desproduct) {
    return <div>Loading...</div>;
  }

  console.log(desproduct.threeXL, "{desproduct.XS}");

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>      <div className="Wishlistdescription-container container mt-5">
        <div className="row">
          {/* Left Section: Image Gallery */}
          <div className="col-md-4">
            <div className="Wishlistdescription-image-gallery">
              <img
                src={`https://api.dremerz.net/uploads/${desproduct.productImage}`}
                alt="Main Product"
                className="img-fluid"
                style={{ borderRadius: "10px" }}
              />
            </div>
          </div>

          {/* Middle Section: Description and Options */}
          <div className="col-md-4" style={{ textAlign: "center" }}>
            <div className="Wishlistdescription-content">
              <span className="Wishlistdescription-sponsored">
                <strong>{desproduct.productBrand}</strong>
              </span>
              <h3 className="Wishlistdescription-title">
                {desproduct.productBrandName}
              </h3>
              <div className="Wishlistdescription-ratings">
                <span className="Wishlistdescription-ratings-reviews">
                  <strong>{desproduct.productDescription}</strong>
                </span>
              </div>
              <ul className="Wishlistdescription-features">
                <li>
                  <strong>{desproduct.productOption1.split(":")[0]}:</strong>
                  {desproduct.productOption1.split(":")[1]}
                </li>
                <li>
                  <strong>{desproduct.productOption2.split(":")[0]}:</strong>
                  {desproduct.productOption1.split(":")[1]}
                </li>
                <li>
                  <strong>{desproduct.productOption3.split(":")[0]}:</strong>
                  {desproduct.productOption1.split(":")[1]}
                </li>
              </ul>
              <div className="Wishlistdescription-pricing">
                <span className="Wishlistdescription-price">
                  Price: ₹{desproduct.productPrice}
                </span>
                {desproduct.originalprice && (
                  <span className="Wishlistdescription-originalprice">
                    ₹{desproduct.productOriginalPrice}
                  </span>
                )}
                {/* <div className="mt-3">
                  <button
                    className="btn deal-buy-now-btn1 me-2"
                    type="button"
                    onClick={() => handleAddtocart(desproduct)}
                  >
                    <i
                      className="fa fa-cart-plus"
                      style={{ color: "white", marginRight: "5px" }}
                    ></i>
                    ADD TO CART
                  </button>
                  <button
                    className="btn deal-buy-now-btn2"
                    type="button"
                    onClick={() => handleWishlist(desproduct)}
                  >
                    <i
                      className="fa fa-heart"
                      style={{ color: "black", marginRight: "5px" }}
                    ></i>
                    WISHLIST
                  </button>
                </div> */}
                {/* fordesktop */}
                <div className="dealoftheday-actions justify-content-around fordesktop">
                  <button
                    className="btn deal-buy-now-btn1"
                    type="button"
                    onClick={() => handleAddtocart(desproduct)}
                    disabled={add?.includes(desproduct.brandName)}
                    style={{ marginRight: "5px" }}
                  >
                    {add.includes(desproduct.brandName) ? (
                      <i
                        className="fa fa-check"
                        style={{ color: "white", marginRight: "2px" }}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-cart-plus"
                        style={{ color: "white", marginRight: "2px" }}
                      ></i>
                    )}
                    ADD TO CART
                  </button>
                </div>
                {/* formobile */}
                <div className="dealoftheday-actions justify-content-around formobile">
                  <button
                    className="btn deal-buy-now-btn1"
                    type="button"
                    onClick={() => handleAddtocart(desproduct)}
                    disabled={add?.includes(desproduct.brandName)}
                    style={{ marginRight: "5px" }}
                  >
                    {add.includes(desproduct.brandName) ? (
                      <i
                        className="fa fa-check"
                        style={{ color: "white", marginRight: "2px" }}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-cart-plus"
                        style={{ color: "white", marginRight: "2px" }}
                      ></i>
                    )}
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section: Additional Images */}
          <div className="col-md-4">
            <div className="Wishlistdescription-images-under-buttons">
              <div className="row previewwishlistdescriptionprevimage">
                {[1, 2, 3, 4].map((index) => (
                  <div className="col-6 mb-3" key={index}>
                    <img
                      src={`https://api.dremerz.net/uploads/${
                        desproduct[`productGalleryImage${index}`]
                      }`}
                      alt={`Preview ${index}`}
                      className="img-fluid"
                      style={{
                        cursor: "pointer",
                        height: "200px",
                        marginLeft: "6px",
                        borderRadius: "10px",
                      }}
                      onClick={() =>
                        handleImageClick(
                          `https://api.dremerz.net/uploads/${
                            desproduct[`productGalleryImage${index}`]
                          }`
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="productleft-container">
            <h5 className="productleft-title">Select Size</h5>
            <div className="productleft-sizes d-flex justify-content-center ">
              {desproduct.XS !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "XS" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("XS")}
                >
                  <span className="productleft-size">XS</span>
                  <span className="productleft-stock">{desproduct.XS}</span>
                </div>
              )}
              {desproduct.S !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "S" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("S")}
                >
                  <span className="productleft-size">S</span>
                  <span className="productleft-stock">{desproduct.S}</span>
                </div>
              )}
              {desproduct.M !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "M" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("M")}
                >
                  <span className="productleft-size">M</span>
                  <span className="productleft-stock">{desproduct.M}</span>
                </div>
              )}
              {desproduct.L !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "L" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("L")}
                >
                  <span className="productleft-size">L</span>
                  <span className="productleft-stock">{desproduct.L}</span>
                </div>
              )}
              {desproduct.XL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "XL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("XL")}
                >
                  <span className="productleft-size">XL</span>
                  <span className="productleft-stock">{desproduct.XL}</span>
                </div>
              )}
              {desproduct.twoXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "twoXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("twoXL")}
                >
                  <span className="productleft-size">2XL</span>
                  <span className="productleft-stock">{desproduct.twoXL}</span>
                </div>
              )}
              {desproduct.threeXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "threeXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("threeXL")}
                >
                  <span className="productleft-size">3XL</span>
                  <span className="productleft-stock">
                    {desproduct.threeXL}
                  </span>
                </div>
              )}
              {desproduct.fourXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "fourXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("fourXL")}
                >
                  <span className="productleft-size">4XL</span>
                  <span className="productleft-stock">{desproduct.fourXL}</span>
                </div>
              )}
              {desproduct.fiveXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "fiveXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("fiveXL")}
                >
                  <span className="productleft-size">5XL</span>
                  <span className="productleft-stock">{desproduct.fiveXL}</span>
                </div>
              )}
              {desproduct.sixXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "sixXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("sixXL")}
                >
                  <span className="productleft-size">6XL</span>
                  <span className="productleft-stock">{desproduct.sixXL}</span>
                </div>
              )}
              {desproduct.sevenXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "sevenXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("sevenXL")}
                >
                  <span className="productleft-size">7XL</span>
                  <span className="productleft-stock">
                    {desproduct.sevenXL}
                  </span>
                </div>
              )}
              {desproduct.eightXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "eightXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("eightXL")}
                >
                  <span className="productleft-size">8XL</span>
                  <span className="productleft-stock">
                    {desproduct.eightXL}
                  </span>
                </div>
              )}
              {desproduct.nineXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "nineXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("nineXL")}
                >
                  <span className="productleft-size">9XL</span>
                  <span className="productleft-stock">{desproduct.nineXL}</span>
                </div>
              )}
              {desproduct.tenXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "tenXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("tenXL")}
                >
                  <span className="productleft-size">10XL</span>
                  <span className="productleft-stock">{desproduct.tenXL}</span>
                </div>
              )}
              {desproduct.elevenXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "elevenXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("elevenXL")}
                >
                  <span className="productleft-size">11XL</span>
                  <span className="productleft-stock">
                    {desproduct.elevenXL}
                  </span>
                </div>
              )}
              {desproduct.twelveXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "twelveXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("twelveXL")}
                >
                  <span className="productleft-size">12XL</span>
                  <span className="productleft-stock">
                    {desproduct.twelveXL}
                  </span>
                </div>
              )}
              {desproduct.thireteenXL !== "0" && (
                <div
                  className={`productleft-size-box ${
                    selectedSize === "thireteenXL" ? "active" : ""
                  }`}
                  onClick={() => handleSizeClick("thireteenXL")}
                >
                  <span className="productleft-size">13XL</span>
                  <span className="productleft-stock">
                    {desproduct.thireteenXL}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {showModal && (
          <div className="modal fade show d-block" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" style={{ color: "#920504" }}>
                    {desproduct.productBrandName}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <img
                    src={modalImage}
                    alt="Preview"
                    className="img-fluid"
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <div className="alertbox">
        {showAlert && (
          <div
            className="modal show"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" style={{ color: "#920504" }}>
                    Dear User
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowAlert(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p style={{ color: "#920504" }}>Please login to continue</p>
                </div>
                <div className="modal-footer">
                  <a href="/login">
                    <button
                      type="button"
                      className="btn"
                      style={{ backgroundColor: "#F58B77", color: "white" }}
                      onClick={() => setShowAlert(false)}
                    >
                      Login
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Wishlistdescription;
